import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatInputModule } from '@angular/material/input'
import { MaskitoModule } from '@maskito/angular'

import { CustomFieldModule } from '../custom-field/custom-field.module'
import { DateSelectorComponent } from './date-selector.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CustomFieldModule,
    MaskitoModule,
    MatDatepickerModule,
    MatInputModule,
  ],
  declarations: [DateSelectorComponent],
  exports: [DateSelectorComponent],
})
export class DateFieldModule {}
